// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img 
              src="/images/UtterRadioLogo.png" 
              alt="Utter Radio" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              Now you're talking!
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/utterradio" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://x.com/Utter_Radio" target="_blank" rel="noreferrer" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="https://www.instagram.com/utterradio" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="https://www.youtube.com/@utterradio" target="_blank" rel="noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
          
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/player">Live Radio</Link></li>
              <li><Link to="/schedule">Schedule</Link></li>
              <li><Link to="/catchup">Catchup</Link></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h4>Content</h4>
            <ul>
              <li><Link to="/podcasts">Blogs</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <ul>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:utterradiouk@gmail.com">utterradiouk@gmail.com</a>
              </li>
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>Orange Tower, Salford M50 2HE</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <img 
              src="/images/isbcLogo.jpg" 
              alt="ISBC Logo" 
              className="footer-logo"
            />
            <img 
              src="/images/SRALogo.png" 
              alt="SRA Logo" 
              className="footer-logo"
            />
            <img 
              src="/images/PRSLogo.png" 
              alt="PRS Logo" 
              className="footer-logo"
            />
            <img 
              src="/images/PPLLogo.png" 
              alt="PPL Logo" 
              className="footer-logo"
            />
        </div>
        <div className="copyright">
              <p>&copy; {currentYear} Utter Radio. All rights reserved.</p>
              <p>Website framework, design, and source code &copy; {currentYear} OnoRadioUK. Adapted by Charlotte Welton for Utter Radio.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;